module.exports = __webpack_public_path__ + "images/deal-filter-checkboxes.png";